import { AlpineComponent } from 'alpinejs';

type ScrollToData = {
  handleBtnClick: (ScrollToTarget: string) => void,
}

export default (): AlpineComponent<ScrollToData> => ({
  handleBtnClick(ScrollToTarget: string) {
    const el = this.$root.querySelector<HTMLElement>(ScrollToTarget);

    if (el) {
      if (window.innerWidth < 992) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }      
    }
  }
});
